<template>
    <div>
        <p class="text-center my-2" v-if="textPosition === 'top'" :style="{ textColor }">{{ title }}</p>
        <pie-progress class="m-auto" :completed-steps="number" :total-steps="100" :color="color"><span
                class="percentage" :style="{ color }">{{ number }}%</span></pie-progress>
        <p class="text-center my-2" v-if="textPosition === 'bottom'" :style="{ textColor }">{{ title }}</p>
    </div>
</template>

<style lang="sass" scoped>
    $primary: #0374d7
    .percentage
        font-size: 1.3rem
        color: $primary

        &.inverse
            color: white
</style>

<script>
    export default {
        props: {
            title: {required: true},
            number: {required: true},
            textPosition: {default: 'top'},
            color: {default: '#0374d7'},
            textColor: {default: 'inherit'},
        },
    };
</script>
